import LegacyHeader from '../LegacyHeader/LegacyHeader.wrapper';
import { LegacyHeaderVariant } from '../LegacyHeader/consts';
import type { EngHeaderProps } from './types';

const EngHeader = (props: EngHeaderProps) => {
  return <LegacyHeader variant={LegacyHeaderVariant.Eng} {...props} />;
};

export default EngHeader;
